import React, { useEffect, useState } from "react";
import Icon from "../../_default/Icon";
import Input from "../../_default/Input";
import exercise from "../../../assets/images/exercise.png";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./Superset.scss";

export default function ExerciseDetails({subitem, idx, setSetOfFirst, setOfFirst, previousValues, isPersonal, isAdmin, exercises, setIdx, subexercise, item, exIdx, removeExercise, onChange, addSubs }) {

  // useEffect(() => {
  //   console.log(item);
  // }, [item.reps])

  useEffect(() => {
    onChange(setOfFirst, "sets", idx);
    // addSubs(setOfFirst)
  }, [setOfFirst])


  return (
    <>
      {isAdmin ? (
        <div class="workout-container">
          { idx === 0 && !subexercise  ? (
            <div class="work-wrapper" style={{width: 100, flexShrink: 0}}>
              <span class="w-title">Sets</span>
              <div class="workout-items">
                <Input type="number" min="1" key={idx} placeholder={item?.subexercises ? item?.subexercises?.length + 1 : 1 } label="Sets" value={item.sets ? item.sets : item?.subexercises ? item?.subexercises?.length + 1 : 1 } onChange={(e) => {
                  onChange(e, "sets", idx);
                  setSetOfFirst(e);
                  addSubs(item.sets);


                }} />
              </div>
            </div>
          ): (
            <div class="work-wrapper" style={{width: 100, flexShrink: 0}}>
              
            </div>
          ) }
          <div class="work-wrapper">
            <span class="w-title" style={{ position: 'relative'}}>Reps</span>
            <div class="workout-items">
              <Input type="number" min="0" placeholder="0" label="Min" value={item.reps} onChange={(e) => onChange(e, "reps", idx)} />
              <Input type="number" min="0" placeholder="0" label="Max" value={item.maxReps} onChange={(e) => onChange(e, "maxReps", idx)} />
            </div>
          </div>

          {console.log("item", item)}
          { (item.category == "Cardio" ||  item.category == "Mobility" || item.starts_with === "Non-applicable") ? (
            <>
              <div class="work-wrapper">
                <span class="w-title">Interval</span>
                <div class="workout-items">
                  <Input type="number" min="0" placeholder="0" label="Active" value={item.up} onChange={(e) => onChange(e, "up", idx)} />
                  <Input type="number" min="0" placeholder="0" label={ item.category == "Mobility" ? 'Release' : 'Rest' } value={item.up_pause} onChange={(e) => onChange(e, "up_pause", idx)} />
                </div>
              </div>
              <div class="work-wrapper">
                <span class="w-title">Info</span> 
                <div class="workout-items">
                  { (item.category == "Cardio") ? (
                    <>
                      <Input type="text" placeholder="..." value={item.speed} onChange={(e) => onChange(e, "speed", idx) } label="Speed" />
                      <Input type="text" placeholder="..." value={item.heart} onChange={(e) => onChange(e, "heart", idx) } label="Heart Rate" />
                    </>
                  ) : <></> }
                  <Input type="text" placeholder="..." value={item.notes} onChange={(e) => onChange(e, "notes", idx) } label="Notes" />
                </div>
              </div>
            </>) : item.starts_with === "Concentric" ? (
              <div class="work-wrapper">
                <span class="w-title" >Tempo</span>
                <div class="workout-items">
                  <Input type="number" min="0" placeholder="0" label="ECC" value={item.up} onChange={(e) => onChange(e, "up", idx)} />
                  <Input type="number" min="0" placeholder="0" label="ISO" value={item.up_pause} onChange={(e) => onChange(e, "up_pause", idx)} />
                  <Input type="number" min="0" placeholder="0" label="CON" value={item.down} onChange={(e) => onChange(e, "down", idx)} />
                  <Input type="number" min="0" placeholder="0" label="ISO" value={item.down_pause} onChange={(e) => onChange(e, "down_pause", idx)} />
                </div>
              </div>
            )  : item.starts_with === "Isometric" ? (
              <div class="work-wrapper">
                <span class="w-title">Tempo</span>
                <div class="workout-items">
                  <Input type="number" min="0" placeholder="0" label="Hold" value={item.hold} onChange={(e) => onChange(e, "hold", idx)} />
                </div>
              </div>
            )  : (
              <div class="work-wrapper">
                <span class="w-title" style={{ position: 'relative'}}>Tempo</span>
                <div class="workout-items">
                  <Input type="number" min="0" placeholder="0" label="ECC" value={item.down} onChange={(e) => onChange(e, "down", idx)} />
                  <Input type="number" min="0" placeholder="0" label="ISO" value={item.down_pause} onChange={(e) => onChange(e, "down_pause", idx)} />
                  <Input type="number" min="0" placeholder="0" label="CON" value={item.up} onChange={(e) => onChange(e, "up", idx)} />
                  <Input type="number" min="0" placeholder="0" label="ISO" value={item.up_pause} onChange={(e) => onChange(e, "up_pause", idx)} />
                </div>
                
              </div>
            )
          }
          {
            (item.category!=="Cardio"&&item.category!=="Mobility")?
            <div class="work-wrapper">
            <span class="w-title">Load</span>
            <div class="workout-items">
              {/* load */}
              <Input type="text" min="0" style={{height:"51px"}} maxLength={"6"} placeholder="0" label="Load" value={item.load} onChange={(e) => onChange(e, "load", idx)} />
            </div>
          </div>:""

          }
          <div class="work-wrapper">
            <span class="w-title">Rest</span>
            <div class="workout-items">
              <Input type="number" min="0" placeholder="0" label="Rest" value={item.rest_time_in_minutes} onChange={(e) => onChange(e, "rest_time_in_minutes", idx)} />
            </div>
          </div>
          {isPersonal  ? <Input type="number" min="0" placeholder="0" label="Kg" value={item.kg} onChange={(e) => onChange(e, "kg", idx)} /> : ""}
          {/* subexercise && <div className="btn-substract"></div> */}
        </div>
      ) : (
        <div className="c-no-admin-workout">
          {item.starts_with === "Up" ? (
            <>
              <div className="c-no-admin-input-replace-workout">
                <span>Up</span>
                <p>{item.up}</p>
              </div>
              <div className="c-no-admin-input-replace-workout">
                <span>Pause</span>
                <p>{item.up_pause}</p>
              </div>
              <div className="c-no-admin-input-replace-workout">
                <span>Down</span>
                <p>{item.down}</p>
              </div>
              <div className="c-no-admin-input-replace-workout">
                <span>Pause</span>
                <p>{item.down_pause}</p>
              </div>
            </>
          ) : (
            <>
              <div className="c-no-admin-input-replace-workout">
                <span>Down</span>
                <p>{item.down}</p>
              </div>
              <div className="c-no-admin-input-replace-workout">
                <span>Pause</span>
                <p>{item.down_pause}</p>
              </div>
              <div className="c-no-admin-input-replace-workout">
                <span>Up</span>
                <p>{item.up}</p>
              </div>
              <div className="c-no-admin-input-replace-workout">
                <span>Pause</span>
                <p>{item.up_pause}</p>
              </div>
            </>
          )}
          <div className="c-no-admin-input-replace-workout">
            <span>Rest</span>
            <p>{item.rest_time_in_minutes}</p>
          </div>
          <div className="c-no-admin-input-replace-workout">
            <span>Reps</span>
            <p>{item.reps}</p>
          </div>
          <div className="c-no-admin-input-replace-workout">
            <span>Sets</span>
            <p>{item.sets}</p>
          </div>
          {isPersonal ? <div className="c-no-admin-input-replace-workout">
            <span>Kg</span>
            <p>{item.kg}</p>
          </div> : ""}
        </div>
      )}
    </>
  );

}




